export default {"src":"/_next/static/media/greenCircle.734fba64.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};